import Loader from "react-loader-spinner";
import { faToggleOff } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, PrinterFill, Search } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import { useForm } from "react-hook-form";
import { fixDamagedProduct, getAllGuaranteeHolders, getFixableSerialsReport } from "../store/api/GuaranteeApi";
import BihamtaTable from "../../Components/BihamtaTable";
import { useDispatch, useSelector } from "react-redux";
import { exportToExcel, setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { getAllProductTypes } from "../store/api/GetAllProduct";
const FixableSerialsReport = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [showFilter, setShowFilter] = useState(true);
    const [holders, setProductHolders] = useState([]);
    const [productTypes, setProductTypes] = useState([]);
    const [filterData, setFilterData] = useState({});
    const [pending, setPending] = useState(false);
    const settingNames = ['ProductGrouppingType'];
    const settings = useSelector(state => state.SystemSettingsReducer.systemSettings)
    const pgType = Array.isArray(settings) && settings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const { handleSubmit, register } = useForm();
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "تایخ تعویض", colName: "PSwapDate", justInMobile: true },
        { colTitle: (pgType === 1 ? "نام محصول" : "نوع محصول"), colName: "ProductName", justInMobile: true },
        { colTitle: "مدل محصول", colName: "ProductModel" },
        { colTitle: "سریال محصول", colName: "SerialNumber" },
        { colTitle: "شماره گارانتی", colName: "GuaranteeCardNo" },
        { colTitle: "تعمیر شده", colName: "IsFixed", colType: "boolean" },
        { colTitle: "تاریخ تعمیر", colName: "PFixDate" }

    ]
    function search(data) {
        const dateFrom = document.getElementsByName("SwapDateFrom")[0].value;
        if (dateFrom !== "") {
            data.SwapDateFrom = filterData.SwapDateFrom;
            data.PDateFrom = dateFrom;
        }
        const dateTo = document.getElementsByName("SwapDateTo")[0].value;
        if (dateTo !== "") {
            data.SwapDateTo = filterData.SwapDateFrom;
            data.PDateTo = dateTo;
        }
        Object.assign(filterData, data);
        dispatch(getFixableSerialsReport(data));
    }
    function toExcel() {
        const url = `api/GuarantyAPI/getFixableSerialsReport`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("FixableSerialsReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/FixableSerialsReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/GuarantyAPI/getFixableSerialsReport`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function rowClick(row) {
        if (row.IsFixed?.toString().toLowerCase() === "true") {
            return;
        }
        const onFix = (res) => {
            if (res.Data) {
                search(filterData);
            }
            else {
                setErrorDialog(dispatch, res.Error, "تعمیر محصول");
            }
        }
        const fix = () => {
            fixDamagedProduct(row.ID, onFix);
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'تعمیر محصول ',
            dialogText: 'آیا از تعمیر محصول مطمئن هستید؟',
            okOperation: fix
        }));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    useEffect(() => {
        dispatch(getSystemSettings(settingNames));
        document.body.classList = "notMain";
        getAllGuaranteeHolders("", setProductHolders);
        getAllProductTypes(setProductTypes);
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faToggleOff} size="lg" />&nbsp;
                    دستگاه های در دست تعمیر
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row id="divFilters" className="rowBorder mt-2">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>تاریخ تعویض از: </label>
                                <DatePicker name="SwapDateFrom" isGregorian={false} timePicker={false} className="form-control" onChange={value => setFilterData({ ...filterData, SwapDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ تعویض تا: </label>
                                <DatePicker name="SwapDateTo" isGregorian={false} timePicker={false} className="form-control" onChange={value => setFilterData({ ...filterData, SwapDateTo: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            {
                                pgType === 1 ?
                                    <Col md={2} className="form-group">
                                        <label>نام محصول:</label>
                                        <Form.Control name="NewProductName" ref={register({})} />
                                    </Col> :
                                    <Fragment>
                                        <Col md={2} className="form-group">
                                            <label>مارک محصول:</label>
                                            <select className="form-control" name="HolderName" ref={register({})}>
                                                <option value="">انتخاب کنید</option>
                                                {Array.isArray(holders) && holders.map((item, i) => <option value={item.HolderName} key={i}>{item.HolderName}</option>)}
                                            </select>
                                        </Col>
                                        <Col md={2} className="form-group">
                                            <label>نوع محصول:</label>
                                            {productTypes === "PENDING" ?
                                                <div className="form-control" style={{ textAlign: "center" }}>
                                                    <Loader type="BallTriangle" color="#bb1370" height={25} width={25} />
                                                </div> :
                                                <select className="form-control" name="ProductType" ref={register({})}>
                                                    <option value="">انتخاب کنید</option>
                                                    {Array.isArray(productTypes) && productTypes.map((item, i) => <option value={item.Name} key={i}>{item.Name}</option>)}
                                                </select>
                                            }
                                        </Col>
                                    </Fragment>
                            }
                            <Col md={2} className="form-group">
                                <label>مدل محصول:</label>
                                <Form.Control name="NewProductModel" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>سریال محصول:</label>
                                <Form.Control name="NewProductSerial" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت تعمیر:</label>
                                <Form.Control as="select" name="IsFixed" ref={register({})} >
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>تعمیر نشده</option>
                                    <option value={true}>تعمیر شده</option>
                                </Form.Control>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد در صفحه:</label>
                                <Form.Control as="select" name="Take" ref={register({})} >
                                    <option value={0}>تمام ردیف ها</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </Form.Control>
                            </Col>
                        </Row>
                        <div className="mt-1">
                            <Button type="submit" className="group-Btn-large"><Search size={18} />&nbsp;جستجوی دستگاه</Button>
                        </div>
                    </form>
                    {!pending &&
                        <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill onClick={printReport} size={25} color="blue" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} reducerName="guaranteeCardsReducer" objectName="fixableSerials" rowClick={rowClick} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default FixableSerialsReport;